logErrorToBackendService.$inject = ['$injector', 'apiBase']

function logErrorToBackendService ($injector, apiBase) {
  var endpointPath = apiBase + 'v3/uniform'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function error (exception, cause) {
    var $http = $http || $injector.get('$http') // eslint-disable-line no-use-before-define
    return $http({
      url: endpoint('jslog'),
      method: 'POST',
      data: { exception: exception, cause: cause }
    })
  }

  return {
    error: error
  }
}

exports.logErrorToBackendService = logErrorToBackendService
